import React from 'react';
import DialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import Dialog, { DialogProps } from '@mui/material/Dialog';

const StyledModal = styled(Dialog)`
  .MuiDialog-paper {
    background-color: ${({ theme }) => theme.colors.offWhite};
    border-radius: 0.75rem;
  }
`;

interface ModalProps {
  open?: boolean;
  onClose?: () => void;
  showCloseButton?: boolean;
  showFooter?: boolean;
  title?: React.ReactNode;
  children?: React.ReactNode;
  dialogProps?: Partial<Omit<DialogProps, 'open' | 'onClose'>>;
  dialogTitleProps?: Partial<DialogTitleProps>;
  disableDivider?: boolean;
}

type Props = ModalProps;

const Modal = ({
  children,
  onClose,
  open,
  title,
  showCloseButton = true,
  showFooter = false,
  dialogProps,
  dialogTitleProps,
  disableDivider,
}: Props) => {
  return (
    <StyledModal
      scroll='paper'
      maxWidth='sm'
      fullWidth
      open={open ?? false}
      onClose={onClose}
      {...dialogProps}
    >
      {(title || onClose) && (
        <DialogTitle
          {...dialogTitleProps}
          sx={{ padding: '2rem', fontWeight: 400, fontSize: '1.5rem', ...dialogTitleProps?.sx }}
        >
          {title}
          {onClose && showCloseButton && (
            <IconButton
              aria-label='close'
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 10,
                top: 10,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
      )}
      {title && !disableDivider && <Divider />}
      {children}
      {showFooter && onClose && (
        <DialogActions sx={{ padding: '1rem 2rem' }}>
          <Button variant='outlined' onClick={onClose} sx={{ textTransform: 'none' }}>
            Close
          </Button>
        </DialogActions>
      )}
    </StyledModal>
  );
};

export default Modal;
